import { render, staticRenderFns } from "./NationalRelocation.vue?vue&type=template&id=7741344a"
import script from "./NationalRelocation.vue?vue&type=script&lang=js"
export * from "./NationalRelocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports